"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPricesByNextPage = void 0;
var _reduxActions = require("redux-actions");
var getPricesByNextPage = exports.getPricesByNextPage = (0, _reduxActions.createAction)('TS_RESULTS/GET_PRICES_BY_NEXT_PAGE');